export default __webpack_public_path__ + "static/media/linkedin.51754cc1.svg";